export default {
  minSearchTermLength: 3,
};
